module.exports = __webpack_public_path__ + "static/media/painting6.59de0b7a.jpg";